import {FormObject} from '../../../hooks/useForm';
import {CSSStyles} from '../../../types/CSSStyles';
import useAppTheme from '../hooks/useAppTheme';

import {css} from '@emotion/react';
import React from 'react';

type BaseRecord = Record<string, unknown>;

export interface Props<T extends BaseRecord> {
  readonly formObject: FormObject<T>;
  readonly children?: React.ReactNode;
  readonly 'data-testid'?: string;
  readonly sx?: CSSStyles;
}

export default function Form<T extends BaseRecord>(
  props: Props<T>,
): JSX.Element {
  const {children, 'data-testid': testID, formObject, sx} = props;
  const {doSubmit} = formObject;
  const {spacing} = useAppTheme();

  return (
    <form
      css={[
        css({
          display: 'flex',
          flexDirection: 'column',
          gap: spacing.x16,
          width: '100%',
        }),
        sx,
      ]}
      data-testid={testID}
      onSubmit={(e) => void doSubmit(e)}
    >
      {children}
    </form>
  );
}
